// nuxt-aos runs with disable: 'mobile': on a phone, AOS.init only strips the
// data-aos attributes of the elements already there and never watches the DOM
// again. An element rendered later (v-if switch after signing in or out, the
// "Sélectionné pour vous" toggle, new slides) keeps the AOS CSS: opacity 0,
// blank blocks on the home. AOS marks the body only when it really runs:
// without that mark, .aos-off shows every [data-aos] element.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:suspense:resolve', () => {
    requestAnimationFrame(() => {
      document.documentElement.classList.toggle(
        'aos-off',
        !document.body.hasAttribute('data-aos-easing'),
      )
    })
  })
})
